import { useState } from "react";

import { ModalComponent } from "../..";
import { getOffsetFromPage } from "../../../../helperFunctions";
import { useFetchPendingMembershipApprovalsQuery } from "../../../../redux/features/approvals/approvals.api";
import {
  MembershipApprovalQuery,
  MembershipApprovalsResponse,
} from "../../../../redux/features/approvals/approvals.type";
import { SingleCooperative } from "../../../../redux/features/cooperative/cooperative.type";
import { SingleBulkMembershipLog } from "../../../../redux/features/membership/membership.type";
import { TableComponent } from "../../../table/table";
import { TimeText } from "../../../typography/timeText";

export const BulkMembershipEntriesModal = ({
  isModalOpen,
  onModalClose,
  cooprativeDetails,
  bulkEntry,
}: {
  isModalOpen: boolean;
  onModalClose: () => void;
  cooprativeDetails: SingleCooperative;
  bulkEntry: SingleBulkMembershipLog;
}) => {
  const [query, setQuery] = useState<MembershipApprovalQuery>({
    limit: 10,
    offset: 0,
    coop: cooprativeDetails.id,
    filelog: true,
    fileId: bulkEntry.id,
  });

  const { data: enntries, isFetching: fetchingEntries } =
    useFetchPendingMembershipApprovalsQuery(
      {
        ...query,
      },
      {
        refetchOnMountOrArgChange: true,
      }
    );

  return (
    <>
      <ModalComponent
        isModalOpen={isModalOpen}
        onModalClose={() => {
          onModalClose();
        }}
        title={`Bulk Upload Entries`}
        topTitle
        subTitle=""
        childrenClassName="flex flex-col gap-6"
        modalClassName="!min-h-[572px] !max-w-[1038px]"
        hasButtons={false}
      >
        <TableComponent
          className="w-full !min-w-max md:!min-w-full"
          isRowClickable={false}
          mobileCardView
          headers={["Name", "Email", "Registration Date"]}
          headerClassName="!bg-white"
          isLoading={fetchingEntries}
          isTableEmpty={[0, undefined].includes(
            (enntries as MembershipApprovalsResponse)?.data?.results?.length
          )}
          isPaginated={true}
          emptrySrc="/assets/images/empty_state_cooperatives.svg"
          emptyTitle="No Entries Found"
          totalCount={(enntries as MembershipApprovalsResponse)?.data?.count}
          itemsPerPage={query?.limit}
          onPageChange={(page) => {
            setQuery({
              ...query,
              offset: getOffsetFromPage(page, query.limit ?? 0),
            });
          }}
          rows={
            (enntries as MembershipApprovalsResponse)?.data?.results?.map(
              (entry, idx) => {
                return {
                  id: entry?.id,
                  items: [
                    <p className="min-w-fit whitespace-nowrap">
                      {entry?.User?.FirstName} {entry?.User?.LastName}
                    </p>,
                    <p>{entry?.User?.Email}</p>,
                    <TimeText
                      timeString={entry.DateAdded}
                      key={`entry-${entry.id}-date-${idx}`}
                    />,
                  ],
                };
              }
            ) ?? []
          }
        />
      </ModalComponent>
    </>
  );
};
